export const jobApplyKey = (job) => {
  const id = job?.job_id ?? job?.id;
  if (id != null && String(id).trim()) return `job:${id}`;
  const url = (job?.job_url || '').trim().toLowerCase();
  if (url) return `url:${url}`;
  const fallback = `${String(job?.role || '').trim().toLowerCase()}|${String(job?.company_name || '').trim().toLowerCase()}`;
  return fallback === '|' ? null : `meta:${fallback}`;
};

export const formatPostedAgo = (postedAt) => {
  if (!postedAt) return '';
  const dt = new Date(postedAt);
  if (Number.isNaN(dt.getTime())) return '';
  const days = Math.floor((Date.now() - dt.getTime()) / 86400000);
  if (days <= 0) return 'Today';
  if (days === 1) return '1d ago';
  if (days < 30) return `${days}d ago`;
  const months = Math.floor(days / 30);
  return `${months}mo ago`;
};

export const formatExperience = (exp) => {
  if (exp == null || exp === '') return null;
  const n = Number(exp);
  if (!Number.isFinite(n)) return String(exp);
  if (n >= 8) return '8+ yrs';
  return `${n}+ yrs`;
};

export const companyInitials = (name) => {
  const parts = String(name || '').trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
};

export const buildPanelParamsFromJob = (job, { initialOuterTab = 'employees', meta = {} } = {}) => {
  const ctx = job?.panel_context || {};
  const sourceNames = meta.source_company_names || job.source_tags || [];
  return {
    sourceOrgId: ctx.source_org_id ?? (job.source_matched_org_ids?.[0] ?? null),
    sourceCompanyName: ctx.source_company_name || sourceNames[0] || '',
    destOrgId: ctx.dest_org_id ?? job.org_id ?? null,
    companyName: ctx.company_name || job.company_name || '',
    hop: ctx.hop || 1,
    role: ctx.role || '',
    location: '',
    initialOuterTab,
    initialSelectedJobId: initialOuterTab === 'jobs' ? (job.job_id ?? job.id) : null,
    initialSelectedJob: initialOuterTab === 'jobs' ? {
      ...job,
      id: job.job_id ?? job.id,
    } : null,
    isFromJobsPage: true,
  };
};
